
const state = {
  askForSaveOnQuit: false,
  saveOnQuit: {}
}

const getters = {
  getAskForSaveOnQuit: state => state.askForSaveOnQuit,
  getSaveOnQuit: state => state.saveOnQuit
}

const actions = {
  'ASK_FOR_SAVE': async function ({ state, commit }) {
    let rep = await state.saveOnQuit.fn()
    return rep
  }
  /* 'ASK_FOR_SAVE': async function ( {state, commit} ) {
    // console.log(this,"ASK_FOR_SAVE",saveOnQuit && saveOnQuit.fn && state.askForSaveOnQuit)
    if (state.askForSaveOnQuit) {
      let repForSave = await this._vm.$msgbox(saveOnQuit.content, title, {
        showCancelButton: true,
        confirmButtonText: saveOnQuit.dialog.confirmAction,
        cancelButtonText: saveOnQuit.dialog.cancelAction })

        console.log(repForSave)

      if (repForSave === 'confirm') {
        if (await saveOnQuit.fn()) {
          commit('UPDATE_ASK_FOR_SAVE_ON_QUIT', false, { root: true })
          return true
        } else {
          throw (new Error('error'))
        }
      }
    }
  } */
}

const mutations = {
  'UPDATE_ASK_FOR_SAVE_ON_QUIT': (state, askForSaveOnQuit) => {
    state.askForSaveOnQuit = askForSaveOnQuit
  },
  'UPDATE_SAVE_ON_QUIT': (state, saveOnQuit) => {
    state.saveOnQuit = saveOnQuit
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
